
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { 
  // Feature,
  FeatureBase,
  // Limitation 
} from "@models";
import { 
  Language, 
} from "@dndModels";
import { CreatureType, DataType, SizeType } from "@dndModels/Types";


export class Race extends DandDFeatureSource {
  data_type: DataType = "race";
  feature_source_type = "Race";
  creature_type: CreatureType = "Humanoid";
  age = "";
  alignment = "";
  sizes: SizeType[] = [3]; // 1 = Tiny, 2 = Small, 3 = Medium, 4 = Large, 5 = Huge, 6 = Gargantuan
  size_description = "";
  speed = 30;

  constructor(obj?: any) {
    super(obj, "Race");
    // this.common_util = DataUtilities.getInstance();
    if (obj) {
      this.creature_type = obj.creature_type ? obj.creature_type : "Humanoid";
      this.age = obj.age ? obj.age : "";
      this.alignment = obj.alignment ? obj.alignment : "";
      this.sizes = [];
      if (obj.sizes) {
        this.sizes = obj.sizes;
      } else if (obj.size) {
        if (obj.size === "Medium") {
          this.sizes.push(3);
        } else if (obj.size === "Small") {
          this.sizes.push(2);
        }
      }
      this.size_description = obj.size_description ? obj.size_description : "";
      this.speed = obj.speed ? +obj.speed : 30;
      if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          o.source_id = this._id;
          o.source_type = this.feature_source_type;
          const feature_base = new FeatureBase(o);
          this.feature_bases.push(feature_base);
        });
      }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.creature_type = obj.creature_type ? obj.creature_type : "Humanoid";
  //     this.age = obj.age ? obj.age : "";
  //     this.alignment = obj.alignment ? obj.alignment : "";
  //     this.sizes = [];
  //     if (obj.sizes) {
  //       this.sizes = obj.sizes;
  //     } else if (obj.size) {
  //       if (obj.size === "Medium") {
  //         this.sizes.push(3);
  //       } else if (obj.size === "Small") {
  //         this.sizes.push(2);
  //       }
  //     }
  //     this.size_description = obj.size_description ? obj.size_description : "";
  //     this.speed = obj.speed ? +obj.speed : 30;
  //     if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
  //       obj.features.forEach((o: any) => {
  //         o.source_id = this._id;
  //         o.source_type = this.feature_source_type;
  //         const feature_base = new FeatureBase(o);
  //         this.feature_bases.push(feature_base);
  //       });
  //     }
  //   }
  // }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      creature_type: this.creature_type,
      age: this.age,
      alignment: this.alignment,
      sizes: this.sizes,
      size_description: this.size_description,
      speed: this.speed,
    };
  }

  toLight(): any {
    const feature_source_obj = super.toLight();
    return {
      ...feature_source_obj,
      creature_type: this.creature_type,
      age: this.age,
      alignment: this.alignment,
      sizes: this.sizes,
      size_description: this.size_description,
      speed: this.speed,
    };
  }

  copy(copyMe: Race, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.creature_type = copyMe.creature_type;
    this.age = copyMe.age;
    this.alignment = copyMe.alignment;
    this.sizes = [...copyMe.sizes];
    this.size_description = copyMe.size_description;
    this.speed = copyMe.speed;
  }

  clone(drop_ids = false): Race {
    const new_obj = new Race();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy5e(copyMe: any, languages: Language[]): void {
    // this.name = copyMe.name;
    // this.age = copyMe.age;
    // this.alignment = copyMe.alignment;
    // this.size = copyMe.size;
    // this.size_description = copyMe.size_description;
    // this.speed = copyMe.speed;
    // this.feature_bases = [];
    // if ((copyMe.ability_bonuses && copyMe.ability_bonuses.length > 0) || copyMe.ability_bonus_options) {
    //   const feature_base = new FeatureBase();
    //   feature_base.name = "Ability Score Increase";
    //   const feature = this.common_util.new_feature_of_type("Ability Score Improvement");
    //   feature.name = "Ability Score Increase";
    //   feature.feature_type = "Ability Score Improvement";
    //   // feature.the_feature = new ASIBaseFeature();
    //   (feature as ASIBaseFeature).allow_duplicates = true;
    //   (feature as ASIBaseFeature).feat_option = false;
      
    //   const asi_features: ASIFeature[] = [];
    //   if (copyMe.ability_bonuses) {
    //     copyMe.ability_bonuses.forEach((ab: any) => {
    //       const asi_feature = new ASIFeature();
    //       asi_feature.id = asi_features.length;
    //       asi_feature.amount = ab.bonus;
    //       asi_feature.options = [];
    //       asi_feature.options.push(ab.ability_score.name);
    //       asi_features.push(asi_feature);
    //     });
    //   }
    //   if (copyMe.ability_bonus_options) {
    //     const options = copyMe.ability_bonus_options;
    //     for (let i = 0; i < options.choose; i++) {
    //       const asi_feature = new ASIFeature();
    //       asi_feature.id = asi_features.length;
    //       asi_feature.options = [];
    //       options.from.forEach((ab: any) => {
    //         asi_feature.amount = ab.bonus;
    //         asi_feature.options.push(ab.ability_score.name);
    //       });
    //       asi_features.push(asi_feature);
    //     }
    //   }
    //   (feature as ASIBaseFeature).asi_features = asi_features;

    //   // feature_base.features.push(feature);
    //   this.feature_bases.push(feature_base);
    // }
    // if ((copyMe.languages && copyMe.languages.length > 0) || copyMe.language_options) {
    //   const feature_base = new FeatureBase();
    //   feature_base.name = "Languages";
    //   if (copyMe.languages) {
    //     copyMe.languages.forEach((l: any) => {
    //       const objFinder = languages.filter(o => o.name === l.name);
    //       if (objFinder.length === 1) {
    //         const feature = this.common_util.new_feature_of_type("Language");
    //         feature.name = l.name;
    //         feature.feature_type = "Language";
    //         // feature.the_feature = new LanguageFeature();
    //         (feature as LanguageFeature).type = "Specific";
    //         (feature as LanguageFeature).language_id = objFinder[0]._id;
    //         // feature_base.features.push(feature);
    //       }
    //     });
    //   }
    //   if (copyMe.language_options) {
    //     for (let i = 0; i < copyMe.language_options.choose; i++) {
    //       const feature = this.common_util.new_feature_of_type("Language");
    //       feature.name = `Language Option ${ i + 1 }`;
    //       feature.feature_type = "Language";
    //       (feature as LanguageFeature).type = "Standard";
    //       // feature_base.features.push(feature);
    //     }
    //   }
    //   this.feature_bases.push(feature_base);
    // }
  }
}